export const MastercardLogo = ({ noBorder = false }) => (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {!noBorder && (
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z"
          fill="white"
        />
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 16.8294C15.9949 17.8275 14.459 18.43 12.7807 18.43C9.03582 18.43 6 15.4303 6 11.73C6 8.02966 9.03582 5.02997 12.7807 5.02997C14.459 5.02997 15.9949 5.63247 17.179 6.63051C18.363 5.63247 19.8989 5.02997 21.5773 5.02997C25.3221 5.02997 28.358 8.02966 28.358 11.73C28.358 15.4303 25.3221 18.43 21.5773 18.43C19.8989 18.43 18.363 17.8275 17.179 16.8294Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1792 16.8294C18.6371 15.6005 19.5616 13.7719 19.5616 11.73C19.5616 9.68801 18.6371 7.85941 17.1792 6.63051C18.3632 5.63247 19.8992 5.02997 21.5775 5.02997C25.3224 5.02997 28.3582 8.02966 28.3582 11.73C28.3582 15.4303 25.3224 18.43 21.5775 18.43C19.8992 18.43 18.3632 17.8275 17.1792 16.8294Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1788 16.8294C18.6367 15.6005 19.5611 13.7719 19.5611 11.73C19.5611 9.68805 18.6367 7.85946 17.1788 6.63055C15.7208 7.85946 14.7964 9.68805 14.7964 11.73C14.7964 13.7719 15.7208 15.6005 17.1788 16.8294Z"
        fill="#FF5E00"
      />
      {!noBorder && (
        <path
          d="M4 1H30V-1H4V1ZM33 4V20H35V4H33ZM30 23H4V25H30V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM33 20C33 21.6569 31.6569 23 30 23V25C32.7614 25 35 22.7614 35 20H33ZM30 1C31.6569 1 33 2.34315 33 4H35C35 1.23858 32.7614 -1 30 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
          fill="#F2F4F7"
        />
      )}
    </svg>
  )
  
  export const VisaLogo = ({ noBorder = false }) => (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {!noBorder && (
        <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" />
      )}
      <g clipPath="url(#clip0_82_3467)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7501 15.8582H8.69031L7.14576 9.79235C7.07245 9.51332 6.91679 9.26664 6.68782 9.15038C6.11639 8.85821 5.48672 8.62568 4.7998 8.50841V8.27487H8.11789C8.57583 8.27487 8.91929 8.62568 8.97653 9.0331L9.77793 13.4086L11.8367 8.27487H13.8392L10.7501 15.8582ZM14.984 15.8582H13.0388L14.6406 8.27487H16.5858L14.984 15.8582ZM19.1025 10.3757C19.1597 9.96725 19.5032 9.73372 19.9039 9.73372C20.5336 9.67508 21.2195 9.79235 21.7919 10.0835L22.1354 8.45079C21.5629 8.21725 20.9333 8.09998 20.3619 8.09998C18.4738 8.09998 17.1 9.15038 17.1 10.6082C17.1 11.7173 18.0731 12.2996 18.7601 12.6504C19.5032 13.0002 19.7894 13.2337 19.7322 13.5835C19.7322 14.1082 19.1597 14.3418 18.5883 14.3418C17.9014 14.3418 17.2145 14.1669 16.5858 13.8747L16.2424 15.5084C16.9293 15.7996 17.6724 15.9169 18.3594 15.9169C20.4763 15.9745 21.7919 14.9251 21.7919 13.35C21.7919 11.3664 19.1025 11.2502 19.1025 10.3757V10.3757ZM28.5998 15.8582L27.0553 8.27487H25.3962C25.0528 8.27487 24.7093 8.50841 24.5948 8.85821L21.7347 15.8582H23.7372L24.1369 14.7502H26.5973L26.8263 15.8582H28.5998ZM25.6824 10.3171L26.2539 13.1751H24.6521L25.6824 10.3171Z"
          fill="#172B85"
        />
      </g>
      {!noBorder && (
        <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" stroke="#F2F4F7" />
      )}
      <defs>
        <clipPath id="clip0_82_3467">
          <rect width="24" height="24" fill="white" transform="translate(5)" />
        </clipPath>
      </defs>
    </svg>
  )
  
  export const VerveLogo = () => (
    <svg
      width="36"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8834 12.0053C13.8834 15.8263 10.7993 18.9238 6.9948 18.9238C3.19016 18.9238 0.105957 15.8263 0.105957 12.0053C0.105957 8.18429 3.19016 5.08677 6.9948 5.08677C10.7993 5.08677 13.8834 8.18429 13.8834 12.0053Z"
        fill="#ED342B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99464 14.9693C5.4538 11.4614 4.32402 8.18443 4.32402 8.18443H1.96191C1.96191 8.18443 3.3996 12.3905 6.07014 17.6504H7.91915C10.5897 12.3905 12.0273 8.18443 12.0273 8.18443H9.66518C9.66518 8.18443 8.53549 11.4614 6.99464 14.9693Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6614 11.644C35.3261 11.644 35.2236 13.0882 35.2236 13.0882H38.099C38.099 13.0882 37.9965 11.644 36.6614 11.644ZM39.8451 14.5322H35.2236C35.2236 14.5322 35.3261 16.0796 37.3804 16.0796C38.4073 16.0796 39.4343 15.7699 39.4343 15.7699L39.6399 17.4202C39.6399 17.4202 38.6128 17.8331 37.1749 17.8331C35.1208 17.8331 33.2722 16.8015 33.2722 13.9133C33.2722 11.644 34.7101 10.1999 36.7641 10.1999C39.8451 10.1999 40.0504 13.2944 39.8451 14.5322ZM24.13 12.0949L24.4481 10.3918C24.4481 10.3918 21.9925 9.64344 19.9966 11.0303V17.8428H22.1163V12.3076C22.9641 11.6692 24.13 12.0949 24.13 12.0949ZM15.2949 11.644C13.9598 11.644 13.8572 13.0882 13.8572 13.0882H16.7327C16.7327 13.0882 16.6302 11.644 15.2949 11.644ZM18.4786 14.5322H13.8572C13.8572 14.5322 13.9598 16.0796 16.0138 16.0796C17.0406 16.0796 18.0678 15.7699 18.0678 15.7699L18.2733 17.4202C18.2733 17.4202 17.2462 17.8331 15.8083 17.8331C13.7543 17.8331 11.9055 16.8015 11.9055 13.9133C11.9055 11.644 13.3435 10.1999 15.3975 10.1999C18.4786 10.1999 18.6838 13.2944 18.4786 14.5322ZM29.3028 15.2391C28.2265 12.6446 27.6886 10.2012 27.6886 10.2012L25.5364 10.2014C25.5364 10.2014 26.6127 14.3742 28.4423 17.8318H30.1634C31.9931 14.3742 33.0693 10.202 33.0693 10.202H30.9171C30.9171 10.202 30.3791 12.6446 29.3028 15.2391Z"
        fill="#03435F"
      />
    </svg>
  )
  
  export const ApplePayLogo = () => (
    <svg
      width="46"
      height="32"
      viewBox="0 0 46 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 6C0 2.68629 2.68629 0 6 0H40C43.3137 0 46 2.68629 46 6V26C46 29.3137 43.3137 32 40 32H6C2.68629 32 0 29.3137 0 26V6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6963 11.1239C12.3095 11.5931 11.6907 11.9632 11.0719 11.9103C10.9945 11.2759 11.2975 10.6018 11.652 10.1855C12.0388 9.70308 12.7156 9.35944 13.2635 9.33301C13.328 9.99385 13.0766 10.6415 12.6963 11.1239ZM13.257 12.0358C12.7118 12.0037 12.2144 12.2039 11.8126 12.3657C11.554 12.4698 11.3351 12.5579 11.1685 12.5579C10.9816 12.5579 10.7536 12.465 10.4976 12.3608C10.1621 12.2242 9.77866 12.068 9.3765 12.0755C8.45472 12.0887 7.5974 12.624 7.12684 13.4765C6.15993 15.1814 6.87544 17.7058 7.81012 19.0936C8.26779 19.7809 8.8157 20.5342 9.53766 20.5078C9.85527 20.4955 10.0837 20.3961 10.3202 20.2933C10.5924 20.1748 10.8752 20.0518 11.3168 20.0518C11.743 20.0518 12.0134 20.1716 12.273 20.2867C12.5198 20.396 12.7569 20.501 13.1088 20.4946C13.8565 20.4814 14.3271 19.8073 14.7847 19.12C15.2786 18.3824 15.4957 17.6625 15.5286 17.5533L15.5325 17.5406C15.5317 17.5398 15.5256 17.537 15.5148 17.5319L15.5148 17.5319C15.3497 17.4544 14.0878 16.8622 14.0757 15.274C14.0635 13.9409 15.0766 13.2655 15.2361 13.1592L15.2361 13.1591C15.2458 13.1527 15.2523 13.1483 15.2553 13.1461C14.6107 12.168 13.6051 12.0623 13.257 12.0358ZM18.4332 20.4219V10.1194H22.2042C24.1509 10.1194 25.511 11.4939 25.511 13.5029C25.511 15.5119 24.1251 16.8996 22.1526 16.8996H19.9932V20.4219H18.4332ZM19.9931 11.4675H21.7915C23.1452 11.4675 23.9187 12.2077 23.9187 13.5095C23.9187 14.8114 23.1452 15.5581 21.785 15.5581H19.9931V11.4675ZM30.6614 19.1861C30.2489 19.9924 29.34 20.5012 28.3602 20.5012C26.9098 20.5012 25.8978 19.6157 25.8978 18.2808C25.8978 16.9591 26.8776 16.1991 28.689 16.0868L30.6357 15.9678V15.3995C30.6357 14.5603 30.1006 14.1043 29.1466 14.1043C28.3602 14.1043 27.7865 14.5206 27.6705 15.155H26.2652C26.3104 13.8201 27.5351 12.8487 29.1917 12.8487C30.9773 12.8487 32.1376 13.8069 32.1376 15.2938V20.4219H30.6937V19.1861H30.6614ZM28.7791 19.2787C27.9476 19.2787 27.419 18.8689 27.419 18.2411C27.419 17.5935 27.9282 17.2168 28.9016 17.1574L30.6356 17.045V17.6266C30.6356 18.5914 29.8362 19.2787 28.7791 19.2787ZM36.9269 20.825C36.3017 22.6291 35.5862 23.2239 34.0649 23.2239C33.9489 23.2239 33.5621 23.2107 33.4719 23.1842V21.9485C33.5685 21.9617 33.807 21.9749 33.9295 21.9749C34.6192 21.9749 35.006 21.6775 35.2445 20.9043L35.3863 20.4483L32.7435 12.9478H34.3743L36.2114 19.0341H36.2437L38.0808 12.9478H39.6665L36.9269 20.825Z"
        fill="black"
      />
      <path
        d="M6 1H40V-1H6V1ZM45 6V26H47V6H45ZM40 31H6V33H40V31ZM1 26V6H-1V26H1ZM6 31C3.23858 31 1 28.7614 1 26H-1C-1 29.866 2.13401 33 6 33V31ZM45 26C45 28.7614 42.7614 31 40 31V33C43.866 33 47 29.866 47 26H45ZM40 1C42.7614 1 45 3.23858 45 6H47C47 2.13401 43.866 -1 40 -1V1ZM6 -1C2.13401 -1 -1 2.13401 -1 6H1C1 3.23858 3.23858 1 6 1V-1Z"
        fill="#F2F4F7"
      />
    </svg>
  )
  
  export const DiscoverLogo = () => (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <path
        d="M14 23L33 17.25V20C33 21.6569 31.6569 23 30 23H14Z"
        fill="#FD6020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3937 9.11084C30.439 9.11084 31.0139 9.59438 31.0139 10.5077C31.0662 11.2062 30.5958 11.7972 29.9686 11.9046L31.3797 13.8925H30.2822L29.0801 11.9584H28.9756V13.8925H28.0871V9.11084H29.3937ZM28.9756 11.3137H29.2369C29.8118 11.3137 30.0731 11.045 30.0731 10.5615C30.0731 10.1317 29.8118 9.86304 29.2369 9.86304H28.9756V11.3137ZM25.0034 13.8925H27.5122V13.0866H25.8919V11.7972H27.4599V10.9913H25.8919V9.91674H27.5122V9.11084H25.0034V13.8925ZM22.3902 12.3345L21.1881 9.11084H20.2474L22.1812 14H22.6515L24.5853 9.11084H23.6446L22.3902 12.3345ZM11.7805 11.5286C11.7805 12.8717 12.8258 14 14.1324 14C14.5505 14 14.9164 13.8925 15.2822 13.7314V12.6568C15.0209 12.9792 14.655 13.1941 14.2369 13.1941C13.4007 13.1941 12.7212 12.5494 12.7212 11.6897V11.5823C12.669 10.7227 13.3484 9.97048 14.1847 9.91675C14.6028 9.91675 15.0209 10.1317 15.2822 10.454V9.37948C14.9686 9.16458 14.5505 9.11085 14.1847 9.11085C12.8258 9.0034 11.7805 10.1317 11.7805 11.5286ZM10.1603 10.9376C9.63762 10.7227 9.48082 10.6152 9.48082 10.3466C9.53309 10.0242 9.79441 9.75557 10.108 9.8093C10.3693 9.8093 10.6306 9.97048 10.8397 10.1854L11.3101 9.54066C10.9442 9.2183 10.4739 9.00339 10.0035 9.00339C9.27176 8.94967 8.64459 9.54066 8.59232 10.2928V10.3466C8.59232 10.9913 8.85365 11.3674 9.68988 11.636C9.89894 11.6897 10.108 11.7972 10.3171 11.9046C10.4739 12.0121 10.5784 12.1733 10.5784 12.3882C10.5784 12.7643 10.2648 13.0866 9.95121 13.0866H9.89894C9.48082 13.0866 9.11497 12.818 8.95818 12.4419L8.38326 13.0329C8.69685 13.6239 9.32403 13.9463 9.95121 13.9463C10.7874 14 11.4669 13.3553 11.5191 12.4956V12.3345C11.4669 11.6897 11.2056 11.3674 10.1603 10.9376ZM7.12892 13.8925H8.01742V9.11084H7.12892V13.8925ZM3 9.11086H4.30662H4.56794C5.8223 9.16458 6.81532 10.2391 6.76306 11.5286C6.76306 12.227 6.44947 12.8717 5.92682 13.3553C5.45644 13.7314 4.88153 13.9463 4.30662 13.8926H3V9.11086ZM4.14983 13.0866C4.56794 13.1404 5.03833 12.9792 5.35191 12.7105C5.6655 12.3882 5.8223 11.9584 5.8223 11.4748C5.8223 11.045 5.6655 10.6152 5.35191 10.2928C5.03833 10.0242 4.56794 9.86302 4.14983 9.91674H3.8885V13.0866H4.14983Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9481 9C16.6415 9 15.5439 10.0745 15.5439 11.4714C15.5439 12.8146 16.5892 13.9429 17.9481 13.9966C19.307 14.0503 20.3523 12.9221 20.4046 11.5252C20.3523 10.1283 19.307 9 17.9481 9V9Z"
        fill="#FD6020"
      />
      <path
        d="M4 1H30V-1H4V1ZM33 4V20H35V4H33ZM30 23H4V25H30V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM33 20C33 21.6569 31.6569 23 30 23V25C32.7614 25 35 22.7614 35 20H33ZM30 1C31.6569 1 33 2.34315 33 4H35C35 1.23858 32.7614 -1 30 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
        fill="#F2F4F7"
      />
    </svg>
  )
  
  export const MaestroLogo = () => (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <path
        d="M19.2576 11.7058C19.2576 15.4092 16.2898 18.4115 12.6288 18.4115C8.96782 18.4115 6 15.4092 6 11.7058C6 8.00227 8.96782 5 12.6288 5C16.2898 5 19.2576 8.00227 19.2576 11.7058Z"
        fill="#ED0006"
      />
      <path
        d="M27.8572 11.7058C27.8572 15.4092 24.8894 18.4115 21.2284 18.4115C17.5674 18.4115 14.5996 15.4092 14.5996 11.7058C14.5996 8.00227 17.5674 5 21.2284 5C24.8894 5 27.8572 8.00227 27.8572 11.7058Z"
        fill="#0099DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9286 6.60193C18.3539 7.83189 19.2576 9.66205 19.2576 11.7057C19.2576 13.7494 18.3539 15.5796 16.9286 16.8096C15.5034 15.5796 14.5996 13.7494 14.5996 11.7057C14.5996 9.66205 15.5034 7.83189 16.9286 6.60193Z"
        fill="#6C6BBD"
      />
      <path
        d="M4 1H30V-1H4V1ZM33 4V20H35V4H33ZM30 23H4V25H30V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM33 20C33 21.6569 31.6569 23 30 23V25C32.7614 25 35 22.7614 35 20H33ZM30 1C31.6569 1 33 2.34315 33 4H35C35 1.23858 32.7614 -1 30 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
        fill="#F2F4F7"
      />
    </svg>
  )
  
  export const DefaultCardLogo = () => (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4167 5C24.8363 5 25.2392 5.16411 25.5361 5.45578C25.833 5.74744 26 6.14333 26 6.55556V17.4444C26 17.8567 25.833 18.2526 25.5361 18.5442C25.2392 18.8359 24.8363 19 24.4167 19H8.58333C8.16375 19 7.76079 18.8359 7.46392 18.5442C7.16704 18.2526 7 17.8567 7 17.4444V6.55556C7 6.14333 7.16704 5.74744 7.46392 5.45578C7.76079 5.16411 8.16375 5 8.58333 5H24.4167ZM25.2083 11.2222H7.79167V17.4444C7.79167 17.8738 8.14633 18.2222 8.58333 18.2222H24.4167C24.8537 18.2222 25.2083 17.8738 25.2083 17.4444V11.2222ZM13.3333 15.1111V15.8889H9.375V15.1111H13.3333ZM23.625 13.5556V14.3333H21.25V13.5556H23.625ZM15.7083 13.5556V14.3333H9.375V13.5556H15.7083ZM7.79167 8.88889V10.4444H25.2083V8.88889H7.79167ZM25.2083 8.11111V6.55556C25.2083 6.12622 24.8537 5.77778 24.4167 5.77778H8.58333C8.14633 5.77778 7.79167 6.12622 7.79167 6.55556V8.11111H25.2083Z"
        fill="#333333"
      />
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" stroke="#F2F4F7" />
    </svg>
  )
  
  export const GreyInfo = ({ className }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="6" cy="6" r="6" fill="#C0B8CC" />
      <path
        d="M7.05663 3.12292C7.05663 2.68132 6.69879 2.32324 6.25719 2.32324C5.81559 2.32324 5.45751 2.68132 5.45751 3.12292C5.45751 3.56452 5.81559 3.9226 6.25719 3.9226C6.69879 3.9226 7.05663 3.56452 7.05663 3.12292Z"
        fill="white"
      />
      <path
        d="M5.55039 9.52828C6.34407 9.92668 6.97407 9.39844 6.97407 9.39844C7.17807 9.25732 7.24911 8.98036 7.12647 8.75788C6.99639 8.521 6.69831 8.43436 6.46143 8.56516C6.46143 8.56516 6.06687 8.77324 6.08199 8.4958C6.08799 8.44708 6.09111 8.42596 6.11175 8.33308L6.25191 7.71676L6.81327 5.25172L6.83223 5.16652C6.86151 5.04028 6.85407 4.90492 6.80271 4.77508C6.66831 4.43332 6.28239 4.26532 5.94063 4.39996L4.50519 4.96516C4.32615 5.03644 4.20015 5.21308 4.20471 5.4166C4.21047 5.67868 4.42695 5.88676 4.68927 5.88076L5.24943 5.86852L5.04375 7.50388L4.96455 8.131C4.96455 8.131 4.86087 8.64244 5.13039 9.11908C5.22543 9.28732 5.37423 9.4402 5.55039 9.52828Z"
        fill="white"
      />
    </svg>
  )
  export const CardIcon = ({ color = '#7535FD' }) => (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.5C0 1.96957 0.210714 1.46086 0.585786 1.08579C0.960859 0.710714 1.46957 0.5 2 0.5H14C14.5304 0.5 15.0391 0.710714 15.4142 1.08579C15.7893 1.46086 16 1.96957 16 2.5V10.5C16 11.0304 15.7893 11.5391 15.4142 11.9142C15.0391 12.2893 14.5304 12.5 14 12.5H2C1.46957 12.5 0.960859 12.2893 0.585786 11.9142C0.210714 11.5391 0 11.0304 0 10.5V2.5ZM2 1.5C1.73478 1.5 1.48043 1.60536 1.29289 1.79289C1.10536 1.98043 1 2.23478 1 2.5V3.5H15V2.5C15 2.23478 14.8946 1.98043 14.7071 1.79289C14.5196 1.60536 14.2652 1.5 14 1.5H2ZM15 5.5H1V10.5C1 10.7652 1.10536 11.0196 1.29289 11.2071C1.48043 11.3946 1.73478 11.5 2 11.5H14C14.2652 11.5 14.5196 11.3946 14.7071 11.2071C14.8946 11.0196 15 10.7652 15 10.5V5.5Z"
        fill={color}
      />
      <path
        d="M2 8.5C2 8.23478 2.10536 7.98043 2.29289 7.79289C2.48043 7.60536 2.73478 7.5 3 7.5H4C4.26522 7.5 4.51957 7.60536 4.70711 7.79289C4.89464 7.98043 5 8.23478 5 8.5V9.5C5 9.76522 4.89464 10.0196 4.70711 10.2071C4.51957 10.3946 4.26522 10.5 4 10.5H3C2.73478 10.5 2.48043 10.3946 2.29289 10.2071C2.10536 10.0196 2 9.76522 2 9.5V8.5Z"
        fill={color}
      />
    </svg>
  )
  
  export const BankIcon = ({ color = '#7535FD' }) => (
    <svg
      width="16"
      height="15"
      viewBox="3 2 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2040_7150)">
        <path
          d="M13.9688 7.7187C14.4516 7.7187 14.6532 7.09839 14.261 6.81245L8.29381 2.47183C8.20859 2.40939 8.1057 2.37573 8.00006 2.37573C7.89442 2.37573 7.79152 2.40939 7.70631 2.47183L1.73912 6.81245C1.34693 7.09683 1.54849 7.7187 2.03287 7.7187H3.00006V13.5625H1.87506C1.80631 13.5625 1.75006 13.6187 1.75006 13.6875V14.5C1.75006 14.5687 1.80631 14.625 1.87506 14.625H14.1251C14.1938 14.625 14.2501 14.5687 14.2501 14.5V13.6875C14.2501 13.6187 14.1938 13.5625 14.1251 13.5625H13.0001V7.7187H13.9688ZM5.95318 13.5625H4.12506V7.7187H5.95318V13.5625ZM8.90631 13.5625H7.07818V7.7187H8.90631V13.5625ZM11.8751 13.5625H10.0313V7.7187H11.8751V13.5625Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2040_7150">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
  export const MobileMoneyIcon = ({ color = "#7535FD" }) => (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7939_17298)">
        <path
          d="M9 2.375C9 1.33936 8.19422 0.5 7.2 0.5H1.8C0.807188 0.5 0 1.33936 0 2.375V13.625C0 14.6592 0.807188 15.5 1.8 15.5H7.2C8.19422 15.5 9 14.6592 9 13.625V2.375ZM7.2 7.29688C7.2 7.68652 6.89766 8 6.525 8H2.475C2.10094 8 1.8 7.68652 1.8 7.29688V4.95312C1.8 4.56348 2.10094 4.25 2.475 4.25H6.525C6.89766 4.25 7.2 4.56348 7.2 4.95312V7.29688ZM6.75 10.8125C6.37734 10.8125 6.075 10.499 6.075 10.1094C6.075 9.71973 6.37734 9.40625 6.75 9.40625C7.12266 9.40625 7.425 9.71973 7.425 10.1094C7.425 10.499 7.12266 10.8125 6.75 10.8125ZM6.75 11.75C7.12266 11.75 7.425 12.0635 7.425 12.4531C7.425 12.8428 7.12266 13.1562 6.75 13.1562C6.37734 13.1562 6.075 12.8428 6.075 12.4531C6.075 12.0635 6.37734 11.75 6.75 11.75ZM4.5 10.8125C4.12594 10.8125 3.825 10.499 3.825 10.1094C3.825 9.71973 4.12594 9.40625 4.5 9.40625C4.87406 9.40625 5.175 9.71973 5.175 10.1094C5.175 10.499 4.87406 10.8125 4.5 10.8125ZM4.5 11.75C4.87406 11.75 5.175 12.0635 5.175 12.4531C5.175 12.8428 4.87406 13.1562 4.5 13.1562C4.12594 13.1562 3.825 12.8428 3.825 12.4531C3.825 12.0635 4.12594 11.75 4.5 11.75ZM2.25 10.8125C1.87594 10.8125 1.575 10.499 1.575 10.1094C1.575 9.71973 1.87594 9.40625 2.25 9.40625C2.62406 9.40625 2.925 9.71973 2.925 10.1094C2.925 10.499 2.62406 10.8125 2.25 10.8125ZM2.25 11.75C2.62406 11.75 2.925 12.0635 2.925 12.4531C2.925 12.8428 2.62406 13.1562 2.25 13.1562C1.87594 13.1562 1.575 12.8428 1.575 12.4531C1.575 12.0635 1.87594 11.75 2.25 11.75ZM5.4 1.90625C5.6475 1.90625 5.85 2.11602 5.85 2.375C5.85 2.63398 5.6475 2.84375 5.4 2.84375H3.6C3.3525 2.84375 3.15 2.63398 3.15 2.375C3.15 2.11602 3.3525 1.90625 3.6 1.90625H5.4Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_7939_17298">
          <rect
            width="9"
            height="15"
            fill="white"
            transform="matrix(-1 0 0 1 9 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
  export const PayAttitude = ({ color = '#7535FD' }) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3875_15939)">
        <g clipPath="url(#clip1_3875_15939)">
          <path
            d="M11 1.5C11.2652 1.5 11.5196 1.60536 11.7071 1.79289C11.8946 1.98043 12 2.23478 12 2.5V14.5C12 14.7652 11.8946 15.0196 11.7071 15.2071C11.5196 15.3946 11.2652 15.5 11 15.5H5C4.73478 15.5 4.48043 15.3946 4.29289 15.2071C4.10536 15.0196 4 14.7652 4 14.5V2.5C4 2.23478 4.10536 1.98043 4.29289 1.79289C4.48043 1.60536 4.73478 1.5 5 1.5H11ZM5 0.5C4.46957 0.5 3.96086 0.710714 3.58579 1.08579C3.21071 1.46086 3 1.96957 3 2.5V14.5C3 15.0304 3.21071 15.5391 3.58579 15.9142C3.96086 16.2893 4.46957 16.5 5 16.5H11C11.5304 16.5 12.0391 16.2893 12.4142 15.9142C12.7893 15.5391 13 15.0304 13 14.5V2.5C13 1.96957 12.7893 1.46086 12.4142 1.08579C12.0391 0.710714 11.5304 0.5 11 0.5H5Z"
            fill={color}
          />
          <path
            d="M8 14.5C8.26522 14.5 8.51957 14.3946 8.70711 14.2071C8.89464 14.0196 9 13.7652 9 13.5C9 13.2348 8.89464 12.9804 8.70711 12.7929C8.51957 12.6054 8.26522 12.5 8 12.5C7.73478 12.5 7.48043 12.6054 7.29289 12.7929C7.10536 12.9804 7 13.2348 7 13.5C7 13.7652 7.10536 14.0196 7.29289 14.2071C7.48043 14.3946 7.73478 14.5 8 14.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3875_15939">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_3875_15939">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
  
  export const CloseIcon = () => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4032_400122)">
        <circle cx="25" cy="24" r="20.5" fill="white" stroke="#F2F4F7" />
        <path
          d="M31 18L19 30M19 18L31 30"
          stroke="#344054"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4032_400122"
          x="0"
          y="0"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4032_400122"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4032_400122"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
  
  export const TestBanner = () => (
    <svg
      width="338"
      height="49"
      viewBox="0 0 338 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4659_17398)">
        <rect x="8" y="4" width="322" height="33" fill="#F6BC41" />
      </g>
      <path
        d="M61.088 16.024H53.228V17.656H56.24V25H58.088V17.656H61.088V16.024ZM69.5643 16.024H67.7163V19.576H64.0803V16.024H62.2203V25H64.0803V21.22H67.7163V25H69.5643V16.024ZM73.2209 16.024H71.3609V25H73.2209V16.024ZM78.0532 15.892C77.0332 15.892 76.2412 16.156 75.6892 16.684C75.1372 17.2 74.8612 17.86 74.8612 18.64C74.8612 19.468 75.1372 20.068 75.7492 20.464C76.0612 20.656 76.3612 20.812 76.6612 20.92C76.9612 21.028 77.3452 21.136 77.8252 21.256C79.1572 21.592 79.6732 21.856 79.6732 22.492C79.6732 23.176 79.2052 23.524 78.2572 23.524C77.2852 23.524 76.5772 22.972 76.5412 22.156L74.6572 22.252C74.6692 23.164 75.0052 23.872 75.6652 24.376C76.3252 24.88 77.1892 25.132 78.2572 25.132C79.2172 25.132 80.0092 24.904 80.6212 24.436C81.2452 23.968 81.5572 23.284 81.5572 22.384C81.5572 21.64 81.3052 21.076 80.8012 20.704C80.3092 20.332 79.5412 20.008 78.5092 19.744C77.8372 19.588 77.3812 19.432 77.1292 19.288C76.8772 19.132 76.7572 18.904 76.7572 18.58C76.7572 17.92 77.2612 17.5 78.0892 17.5C78.9412 17.5 79.4692 17.98 79.4812 18.748L81.3772 18.652C81.3532 17.8 81.0412 17.128 80.4292 16.636C79.8292 16.144 79.0372 15.892 78.0532 15.892ZM92.8693 16.024H85.0093V17.656H88.0213V25H89.8693V17.656H92.8693V16.024ZM101.202 25L99.2936 21.472C100.206 21.028 100.734 20.14 100.734 18.904C100.734 18.004 100.47 17.296 99.9416 16.792C99.4136 16.276 98.7176 16.024 97.8416 16.024H94.0016V25H95.8616V21.772H97.3616L99.1136 25H101.202ZM95.8496 17.656H97.6136C98.3456 17.656 98.8496 18.1 98.8496 18.904C98.8496 19.672 98.3456 20.128 97.6136 20.128H95.8496V17.656ZM107.094 16.024H105.534L101.682 25H103.71L104.454 23.272H108.186L108.918 25H110.958L107.094 16.024ZM106.326 18.892L107.538 21.76H105.114L106.326 18.892ZM119.323 16.024H117.475V21.592L113.527 16.024H111.955V25H113.815V19.444L117.751 25H119.323V16.024ZM124.155 15.892C123.135 15.892 122.343 16.156 121.791 16.684C121.239 17.2 120.963 17.86 120.963 18.64C120.963 19.468 121.239 20.068 121.851 20.464C122.163 20.656 122.463 20.812 122.763 20.92C123.063 21.028 123.447 21.136 123.927 21.256C125.259 21.592 125.775 21.856 125.775 22.492C125.775 23.176 125.307 23.524 124.359 23.524C123.387 23.524 122.679 22.972 122.643 22.156L120.759 22.252C120.771 23.164 121.107 23.872 121.767 24.376C122.427 24.88 123.291 25.132 124.359 25.132C125.319 25.132 126.111 24.904 126.723 24.436C127.347 23.968 127.659 23.284 127.659 22.384C127.659 21.64 127.407 21.076 126.903 20.704C126.411 20.332 125.643 20.008 124.611 19.744C123.939 19.588 123.483 19.432 123.231 19.288C122.979 19.132 122.859 18.904 122.859 18.58C122.859 17.92 123.363 17.5 124.191 17.5C125.043 17.5 125.571 17.98 125.583 18.748L127.479 18.652C127.455 17.8 127.143 17.128 126.531 16.636C125.931 16.144 125.139 15.892 124.155 15.892ZM133.485 16.024H131.925L128.073 25H130.101L130.845 23.272H134.577L135.309 25H137.349L133.485 16.024ZM132.717 18.892L133.929 21.76H131.505L132.717 18.892ZM142.054 15.892C140.71 15.892 139.618 16.312 138.766 17.14C137.914 17.968 137.494 19.084 137.494 20.512C137.494 21.928 137.914 23.056 138.766 23.884C139.618 24.712 140.722 25.132 142.066 25.132C143.17 25.132 144.118 24.832 144.898 24.22C145.678 23.608 146.158 22.792 146.326 21.748L144.382 21.58C144.142 22.816 143.254 23.488 142.006 23.488C141.238 23.488 140.602 23.224 140.11 22.708C139.618 22.192 139.378 21.46 139.378 20.512C139.378 19.612 139.618 18.892 140.086 18.352C140.566 17.812 141.202 17.536 141.994 17.536C143.242 17.536 144.13 18.232 144.382 19.48L146.314 19.312C146.158 18.268 145.678 17.428 144.886 16.816C144.106 16.204 143.158 15.892 142.054 15.892ZM154.908 16.024H147.048V17.656H150.06V25H151.908V17.656H154.908V16.024ZM157.901 16.024H156.041V25H157.901V16.024ZM164.053 15.892C162.685 15.892 161.569 16.312 160.693 17.164C159.817 18.004 159.385 19.12 159.385 20.512C159.385 21.904 159.817 23.02 160.693 23.872C161.569 24.712 162.685 25.132 164.053 25.132C165.409 25.132 166.525 24.712 167.401 23.872C168.277 23.02 168.709 21.904 168.709 20.512C168.709 19.12 168.277 18.004 167.401 17.164C166.525 16.312 165.409 15.892 164.053 15.892ZM164.053 17.536C164.881 17.536 165.541 17.8 166.045 18.34C166.561 18.868 166.813 19.588 166.813 20.512C166.813 21.424 166.561 22.144 166.045 22.684C165.541 23.224 164.881 23.488 164.053 23.488C163.225 23.488 162.553 23.224 162.037 22.684C161.521 22.144 161.269 21.424 161.269 20.512C161.269 19.588 161.521 18.868 162.037 18.34C162.553 17.8 163.225 17.536 164.053 17.536ZM177.565 16.024H175.717V21.592L171.769 16.024H170.197V25H172.057V19.444L175.993 25H177.565V16.024ZM183.928 16.024H182.068V25H183.928V16.024ZM188.76 15.892C187.74 15.892 186.948 16.156 186.396 16.684C185.844 17.2 185.568 17.86 185.568 18.64C185.568 19.468 185.844 20.068 186.456 20.464C186.768 20.656 187.068 20.812 187.368 20.92C187.668 21.028 188.052 21.136 188.532 21.256C189.864 21.592 190.38 21.856 190.38 22.492C190.38 23.176 189.912 23.524 188.964 23.524C187.992 23.524 187.284 22.972 187.248 22.156L185.364 22.252C185.376 23.164 185.712 23.872 186.372 24.376C187.032 24.88 187.896 25.132 188.964 25.132C189.924 25.132 190.716 24.904 191.328 24.436C191.952 23.968 192.264 23.284 192.264 22.384C192.264 21.64 192.012 21.076 191.508 20.704C191.016 20.332 190.248 20.008 189.216 19.744C188.544 19.588 188.088 19.432 187.836 19.288C187.584 19.132 187.464 18.904 187.464 18.58C187.464 17.92 187.968 17.5 188.796 17.5C189.648 17.5 190.176 17.98 190.188 18.748L192.084 18.652C192.06 17.8 191.748 17.128 191.136 16.636C190.536 16.144 189.744 15.892 188.76 15.892ZM198.248 16.024H196.388V25H198.248V16.024ZM207.413 16.024H205.565V21.592L201.617 16.024H200.045V25H201.905V19.444L205.841 25H207.413V16.024ZM219.104 16.024H211.244V17.656H214.256V25H216.104V17.656H219.104V16.024ZM225.996 16.024H220.236V25H226.008V23.356H222.096V21.196H225.48V19.6H222.096V17.656H225.996V16.024ZM230.491 15.892C229.471 15.892 228.679 16.156 228.127 16.684C227.575 17.2 227.299 17.86 227.299 18.64C227.299 19.468 227.575 20.068 228.187 20.464C228.499 20.656 228.799 20.812 229.099 20.92C229.399 21.028 229.783 21.136 230.263 21.256C231.595 21.592 232.111 21.856 232.111 22.492C232.111 23.176 231.643 23.524 230.695 23.524C229.723 23.524 229.015 22.972 228.979 22.156L227.095 22.252C227.107 23.164 227.443 23.872 228.103 24.376C228.763 24.88 229.627 25.132 230.695 25.132C231.655 25.132 232.447 24.904 233.059 24.436C233.683 23.968 233.995 23.284 233.995 22.384C233.995 21.64 233.743 21.076 233.239 20.704C232.747 20.332 231.979 20.008 230.947 19.744C230.275 19.588 229.819 19.432 229.567 19.288C229.315 19.132 229.195 18.904 229.195 18.58C229.195 17.92 229.699 17.5 230.527 17.5C231.379 17.5 231.907 17.98 231.919 18.748L233.815 18.652C233.791 17.8 233.479 17.128 232.867 16.636C232.267 16.144 231.475 15.892 230.491 15.892ZM242.6 16.024H234.74V17.656H237.752V25H239.6V17.656H242.6V16.024ZM256.315 16.024H254.683L251.395 22.192L248.083 16.024H246.439V25H248.299V20.152L250.783 24.904H252.007L254.479 20.152V25H256.315V16.024ZM262.479 15.892C261.111 15.892 259.995 16.312 259.119 17.164C258.243 18.004 257.811 19.12 257.811 20.512C257.811 21.904 258.243 23.02 259.119 23.872C259.995 24.712 261.111 25.132 262.479 25.132C263.835 25.132 264.951 24.712 265.827 23.872C266.703 23.02 267.135 21.904 267.135 20.512C267.135 19.12 266.703 18.004 265.827 17.164C264.951 16.312 263.835 15.892 262.479 15.892ZM262.479 17.536C263.307 17.536 263.967 17.8 264.471 18.34C264.987 18.868 265.239 19.588 265.239 20.512C265.239 21.424 264.987 22.144 264.471 22.684C263.967 23.224 263.307 23.488 262.479 23.488C261.651 23.488 260.979 23.224 260.463 22.684C259.947 22.144 259.695 21.424 259.695 20.512C259.695 19.588 259.947 18.868 260.463 18.34C260.979 17.8 261.651 17.536 262.479 17.536ZM268.623 25H272.307C273.615 25 274.695 24.604 275.523 23.8C276.351 22.996 276.771 21.892 276.771 20.512C276.771 19.132 276.351 18.04 275.523 17.236C274.695 16.432 273.627 16.024 272.319 16.024H268.623V25ZM272.331 17.608C273.951 17.608 274.935 18.628 274.935 20.512C274.935 22.396 273.927 23.416 272.331 23.416H270.471V17.608H272.331ZM284.015 16.024H278.255V25H284.027V23.356H280.115V21.196H283.499V19.6H280.115V17.656H284.015V16.024Z"
        fill="#190256"
      />
      <defs>
        <filter
          id="filter0_d_4659_17398"
          x="0"
          y="0"
          width="338"
          height="49"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4659_17398"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4659_17398"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
  